import { eventTracker } from 'app/modules/Segment';
import {
  buildJusfyEventsContext,
  buildJusfyEventsProperties,
} from 'app/modules/Segment/buildJusfyEvent';
import { FeatureEnum, TContext } from 'app/modules/Segment/types';
import { buildApiErrorProperties } from 'app/services/tracking/apiErrorProperties';

export type OnboardingStep = 'oab' | 'profile' | 'photo' | 'tools' | 'address';

export type OnboardingErrorAction =
  | 'pending_fetch'
  | 'oab_setup'
  | 'oab_confirm'
  | 'report_config_fetch'
  | 'report_config_save'
  | 'office_save'
  | 'logo_upload'
  | 'photo_upload'
  | 'step_complete'
  | 'address_save'
  | 'address_confirm_timeout';

const ONBOARDING_ERROR_EVENT = 'onboarding_error';

const onboardingErrorContext: TContext = buildJusfyEventsContext({
  component: 'onboarding-flow',
});

export function trackOnboardingError(
  onboardingStep: OnboardingStep,
  errorAction: OnboardingErrorAction,
  error: unknown,
): void {
  eventTracker.track({
    event: ONBOARDING_ERROR_EVENT,
    properties: buildJusfyEventsProperties({
      event: ONBOARDING_ERROR_EVENT,
      feature: FeatureEnum.ONBOARDING,
      eventMeaning:
        '[Onboarding] Uma chamada de API do onboarding falhou. Evento passivo, não é ação do usuário: error_action identifica o ponto do fluxo que falhou e onboarding_step a tela em que aconteceu. Mapeamento de onboarding_step para os eventos de sucesso: oab -> onboarding_oab_*, profile -> onboarding_profile_*, photo -> tela /onboarding/foto (ainda sem eventos de sucesso), tools -> onboarding_ferramentas_*, address -> onboarding_address_*.',
      relevantUserActivity: false,
      extraProperties: {
        onboarding_step: onboardingStep,
        error_action: errorAction,
        ...buildApiErrorProperties(error),
      },
    }),
    context: onboardingErrorContext,
  });
}

export { ONBOARDING_ERROR_EVENT };
